import {connect} from 'react-redux';
import ErrorMessage from './ErrorMessage';
import {hideGlobalErrorMessage} from '../../actions/globalErrorMessage/hideGlobalErrorMessage';

const mapStateToProps = ({
                           globalErrorMessage: {showErrorMessage, message},
                           locales: {current: currentLocale}
                         }) => ({
  showErrorMessage,
  message,
  currentLocale
});

export default connect(
  mapStateToProps,
  {hideGlobalErrorMessage}
)(ErrorMessage);
